/* eslint-disable */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import logo64 from 'imgs/encoded/brasaosspds.base64';
import moment from 'moment';

export const pdfGen = contents => {
  const win = window.open('', '_blank');
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const reportTitle = [
    {
      image: logo64,
      width: 179,
      height: 63,
      alignment: 'center',
      margin: [0, 10, 0, 0],
    },
    {
      text: 'Alertas dos veículos.\n',
      bold: true,
      fontSize: 13,
      alignment: 'center',
      margin: [0, 4, 0, 0],
    },
    {
      text: `Segue abaixo a lista com informações de veículos (${contents.length}).\n`,
      bold: false,
      fontSize: 9,
      alignment: 'center',
      margin: [0, 4, 0, 0],
    },
  ];
  const results = contents.map(m => {
    return [
      { text: m.placa, fontSize: 9, margin: [0, 2, 0, 2] },
      { text: m.prefixo, fontSize: 9, margin: [0, 2, 0, 2] },
      { text: m.tipoAlerta, fontSize: 9, margin: [0, 2, 0, 2] },
      { text: m.nomeCerca, fontSize: 9, margin: [0, 2, 0, 2] },
      {
        text: moment(m.datePosition).format('DD/MM/YYYY HH:mm:ss'),
        fontSize: 9,
        margin: [0, 2, 0, 2],
      },
    ];
  });

  const details = [
    {
      alignment: 'center',
      margin: [0, 0, 0, 0],
      layout: {
        fillColor(rowIndex) {
          return rowIndex % 2 === 0 ? '#CCCCCC' : null;
        },
      },

      table: {
        headerRows: 1,
        widths: ['10%', '10%', '15%', '35%', '30%'],
        body: [
          [
            { text: 'Placa', style: 'tableHeader', fontSize: 10 },
            { text: 'Prefixo', style: 'tableHeader', fontSize: 10 },
            { text: 'Alerta', style: 'tableHeader', fontSize: 10 },
            { text: 'Cerca', style: 'tableHeader', fontSize: 10 },
            { text: 'Data', style: 'tableHeader', fontSize: 10 },
          ],
          ...results,
        ],
      },
    },
  ];
  const footer = [
    {
      text: [
        {
          text:
            'Secretaria de Segurança Pública e Defesa Social. Avenida Bezerra de Menezes, 581 - São Gerardo\n CEP 60325-003 . Fortaleza Ceará . Fone: (85) 3101-6501',
        },
      ],
      fontSize: 8,
      margin: [0, 10, 0, 45],
      alignment: 'center',
    },
  ];

  const docDefinitions = {
    pageMargins: [50, 140, 40, 40],
    pageSize: 'A4',
    alignment: 'center',
    header: [reportTitle],
    content: [details],
    footer: [footer],
  };
  pdfMake.createPdf(docDefinitions).open({}, win);
};

export default () => pdfGen;

